import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AtlasChatPersistedMessage,
  AtlasChatPersistedSession,
  AtlasChatSessionListResponse,
  AtlasChatUsageStatusResponse,
  CreateAtlasChatMessageRequest,
  CreateAtlasChatSessionRequest,
  UpdateAtlasChatMessageRequest,
  UpdateAtlasChatSessionRequest
} from '@secca/shared/models/atlas/atlas-chat.model';
import { Observable } from 'rxjs';
import { AtlasApiService } from './atlas-api.service';

@Injectable({
  providedIn: 'root'
})
export class AtlasChatService {
  constructor(
    private http: HttpClient,
    private atlasApiService: AtlasApiService
  ) {}

  listAtlasChatSessions(options: { caseNumber?: string; includeMessages?: boolean; limit?: number; offset?: number } = {}): Observable<AtlasChatSessionListResponse> {
    let params = new HttpParams();
    if (options.caseNumber) {
      params = params.set('case_number', options.caseNumber);
    }
    if (options.includeMessages != null) {
      params = params.set('include_messages', String(options.includeMessages));
    }
    if (options.limit != null) {
      params = params.set('limit', String(options.limit));
    }
    if (options.offset != null) {
      params = params.set('offset', String(options.offset));
    }

    return this.atlasApiService.withAtlasAuth(headers =>
      this.http.get<AtlasChatSessionListResponse>(this.atlasApiService.buildUrl('/api/v1/chat-sessions'), { headers, params })
    );
  }

  createAtlasChatSession(request: CreateAtlasChatSessionRequest): Observable<AtlasChatPersistedSession> {
    return this.atlasApiService.withAtlasAuth(headers =>
      this.http.post<AtlasChatPersistedSession>(this.atlasApiService.buildUrl('/api/v1/chat-sessions'), request, { headers })
    );
  }

  getAtlasChatUsageStatus(): Observable<AtlasChatUsageStatusResponse> {
    return this.atlasApiService.withAtlasAuth(headers =>
      this.http.get<AtlasChatUsageStatusResponse>(this.atlasApiService.buildUrl('/api/v1/chat-sessions/usage'), { headers })
    );
  }

  updateAtlasChatSession(chatSessionId: string, request: UpdateAtlasChatSessionRequest): Observable<AtlasChatPersistedSession> {
    return this.atlasApiService.withAtlasAuth(headers =>
      this.http.patch<AtlasChatPersistedSession>(this.atlasApiService.buildUrl(`/api/v1/chat-sessions/${chatSessionId}`), request, { headers })
    );
  }

  deleteAtlasChatSession(chatSessionId: string): Observable<void> {
    return this.atlasApiService.withAtlasAuth(headers =>
      this.http.delete<void>(this.atlasApiService.buildUrl(`/api/v1/chat-sessions/${chatSessionId}`), { headers })
    );
  }

  addAtlasChatMessage(chatSessionId: string, request: CreateAtlasChatMessageRequest): Observable<AtlasChatPersistedMessage> {
    return this.atlasApiService.withAtlasAuth(headers =>
      this.http.post<AtlasChatPersistedMessage>(this.atlasApiService.buildUrl(`/api/v1/chat-sessions/${chatSessionId}/messages`), request, { headers })
    );
  }

  updateAtlasChatMessage(chatSessionId: string, messageId: string, request: UpdateAtlasChatMessageRequest): Observable<AtlasChatPersistedMessage> {
    return this.atlasApiService.withAtlasAuth(headers =>
      this.http.patch<AtlasChatPersistedMessage>(this.atlasApiService.buildUrl(`/api/v1/chat-sessions/${chatSessionId}/messages/${messageId}`), request, { headers })
    );
  }

  continueAtlasChatSession(chatSessionId: string): Observable<AtlasChatPersistedSession> {
    return this.atlasApiService.withAtlasAuth(headers =>
      this.http.post<AtlasChatPersistedSession>(this.atlasApiService.buildUrl(`/api/v1/chat-sessions/${chatSessionId}/continue`), {}, { headers })
    );
  }
}
